'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getItems = exports.getChangedDeselection = exports.getChangedSelection = exports.getSelection = undefined;

var _yourchoice = require('yourchoice');

var _flow = require('lodash/flow');

var _flow2 = _interopRequireDefault(_flow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function defaultState(state) {
  if (state === null || state === undefined) {
    return (0, _yourchoice.init)();
  }

  return state;
}

function withDefaultState(selector) {
  return (0, _flow2.default)(defaultState, selector);
}

var getSelectionDefault = withDefaultState(_yourchoice.getSelection);
var getChangedSelectionDefault = withDefaultState(_yourchoice.getChangedSelection);
var getChangedDeselectionDefault = withDefaultState(_yourchoice.getChangedDeselection);
var getItemsDefault = withDefaultState(_yourchoice.getItems);

exports.getSelection = getSelectionDefault;
exports.getChangedSelection = getChangedSelectionDefault;
exports.getChangedDeselection = getChangedDeselectionDefault;
exports.getItems = getItemsDefault;


//////////////////
// WEBPACK FOOTER
// ./~/yourchoice-redux/lib/selectors.js
// module id = 159
// module chunks = 0